// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".historyFrom[data-v-06d1b34a]{width:1200px;margin:0 auto;height:700px}.historyFrom .el-card[data-v-06d1b34a]{height:100%}.historyFrom .title[data-v-06d1b34a]{font-size:34px;display:block;padding-top:30px}.historyFrom .el-pagination[data-v-06d1b34a]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
